module.exports = __webpack_public_path__ + "img/RL210.c718e3ab.png";